import { Button } from '@thd-olt-component-react/core-ui';
import React from 'react';
import proptypes from 'prop-types';
const { func, string, ...PropTypes } = proptypes;
import { HashLink } from 'react-router-hash-link';

function LinkButton({ children, onClick, to, testId }) {

  return to
    ? (
      <HashLink to={to} onClick={onClick}>
        {children}
      </HashLink>
    )
    : (
      <Button
        transparent
        link
        inline
        tag="a"
        className="epc-button-inline"
        contentClass="epc-button-inline__content"
        onClick={onClick}
        data-testid={testId}
      >
        {children}
      </Button>
    );
}

LinkButton.propTypes = {
  onClick: func,
  to: string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  testId: string,
};

LinkButton.defaultProps = {
  onClick: () => {},
  to: null,
  testId: null,
};

export default LinkButton;
